var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 24h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7 20h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5 16h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13 23.955a1 1 0 0 1 -.089-2 10 10 0 1 0 -10.87-10.865 1 1 0 0 1 -1.992-.18 12 12 0 0 1 23.951 1.09 11.934 11.934 0 0 1 -10.91 11.951c-.03.003-.061.004-.09.004z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m12 6a1 1 0 0 0 -1 1v5a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414l-2.707-2.707v-4.586a1 1 0 0 0 -1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFast);
export default __webpack_public_path__ + "static/media/time-fast.8e8166cdb3196c3825ad8655aa5ce4a3.svg";
export { ForwardRef as ReactComponent };